import { use, useContext, useEffect, useState } from 'react';
import { AppContext } from 'App.context';
import { ApiContext } from 'utils/networking/Api.context';
import { notification } from 'antd';

const useCopyFormHotelSelectorHook = onHotelSelected => {
  const { appState, appActions } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    hotels: [],
    compatibleHotelList: [],
    uncompatibleHotelList: [],
    selectedHotels: [],
    loadedHotels: false,
  });

  function updateState(object) {
    setState(prev => ({ ...prev, ...object }));
  }

  useEffect(() => {
    API.getCopyFormConfigCompatibility(appActions.getSelectedHotel()?.id)
      .then(res => {
        updateState({
          compatibleHotelList: res.data.compatibleHotels,
          uncompatibleHotelList: res.data.incompatibleHotels,
          loadedHotels: true,
        });
      })
      .catch(err => {
        notification.error({
          message: appActions.translate('guestTable.compatibilityLoadError'),
        });
      });
  }, []);

  const actions = {
    clearSelectedHotels: () => {
      updateState({ selectedHotels: [] });
      if (onHotelSelected) {
        onHotelSelected([]);
      }
    },
    handleChange: value => {
      if (!Array.isArray(value)) return;

      updateState({ selectedValue: value });

      if (onHotelSelected) {
        const selectedHotels = state.hotels
          .filter(h => value.includes(h.id === null ? 'null' : h.id))
          .map(h => ({ hotelId: h.id, hotelName: h.name }));

        onHotelSelected(selectedHotels);
      }
    },

    onSelectNewHotel: value => {
      updateState({
        selectedHotels: [...state.selectedHotels, value === 'null' ? null : value],
      });

      onHotelSelected([...state.selectedHotels, value === 'null' ? null : value]);
    },

    onDeselectNewHotel: value => {
      updateState({
        selectedHotels: state.selectedHotels.filter(h => h !== (value === 'null' ? null : value)),
      });

      onHotelSelected(state.selectedHotels.filter(h => h !== (value === 'null' ? null : value)));
    },
  };

  return { state, actions };
};

export default useCopyFormHotelSelectorHook;
